import {
  // Trick prettier to format css
  createGlobalStyle as css
} from 'styled-components';
import { th } from 'style/theme';
import { sizes } from './index';
import './fonts.css';

const GlobalStyle = css`
  :root {
    --nav-height: 64px;
  }

  html,
  body {
    width: 100%;
  }

  input,
  textarea,
  select {
    outline: none;
    border: 0;
  }

  body {
    margin: 0;
    padding: 0;
    font: 100%/1.33 ${th('fonts.body')};
    letter-spacing: ${th('fonts.paragraphSpacing')};
    color: ${th('colors.primaryText')};
    background-color: ${th('colors.black')};
    -webkit-tap-highlight-color: ${th('colors.tapHighlight')};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  * {
    box-sizing: border-box;
  }

  h1 {
    font-size: 30px;
    margin: 0;
    line-height: 1;
    letter-spacing: -1.34px;

    @media ${sizes.tabletPortrait} {
      font-size: 40px;
    }
  }

  h1,
  h2,
  h3,
  h4 {
    letter-spacing: initial;
  }
`;

export default GlobalStyle;
